module.exports = __webpack_public_path__ + "img/thumbnail_DesertHornedViper_u_normal.426f0cad.png";